import {Text} from 'platform/foundation';

import {getLocaleLanguageLabel} from '@dms/shared';

import {RequiredTestIdProps} from 'shared/web';

interface LocaleTemplateHeadingProps extends RequiredTestIdProps {
  locale: string;
}

/**
 * Shows the translated language name without the locale code.
 */
export function LocaleTemplateHeading(props: LocaleTemplateHeadingProps) {
  return (
    <Text size="small" alternative data-testid={props['data-testid']}>
      {getLocaleLanguageLabel(props.locale)}
    </Text>
  );
}
